import { Brick, registerBrick } from 'olympe';

export default class GetRoute extends Brick {

    get route() {
        return new RegExp('#\/*(.+)').exec(location.hash)?.[1] ?? '';
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function(*)} getRoute
     */
    update($, inputs, [SetCurrentRoute]) {
        const onRoute = () => SetCurrentRoute(this.route);
        window.addEventListener('hashchange', onRoute);
        $.onClear(() => window.removeEventListener('hashchange', onRoute));
        onRoute();
    }
}

registerBrick('01880f4b2e8e8e1813e9', GetRoute);
